import {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {Form as FormikForm, FormField, SubmitButton} from "../../../../components/forms"
import {useParams} from "react-router-dom";
import offersApi from "../../../../api/offertes";
import notyf from "../../../../utils/notyfApi";

function OfferProjectFormsModal({ name, reference, reload}) {
    const {id} = useParams();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSubmit = async (sid, data) => {
        const response = await offersApi.createNewForm({
            project_form_project_id: parseInt(sid),
            project_form_risc_percentage: 3,
            ...data
        });
        if (!response.ok) return notyf.error("Error " + response.status)
        reload()
        handleClose()
    };

    return (
        <>
             <Button variant="primary" className={"float-end"} onClick={handleShow}>
                +
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title> Nieuw project formulier aanmaken
                    </Modal.Title>
                </Modal.Header>
                <FormikForm
                    initialValues={{
                        project_form_name: name || "",
                        project_form_code: reference || "",
                    }}

                    // Hier is het validatieschema van alle velden
                    // validationSchema={Yup.object({
                    //     calculation_name: Yup.string()
                    //         .max(250, 'Moet minder dan 250 karakters zijn')
                    //         .trim()
                    //         .required('Project formulier naam moet ingevuld worden'),
                    //     calculation_reference: Yup.string()
                    //         .max(250, 'Moet minder dan 250 karakters zijn')
                    //         .trim()
                    //         .required('Project formulier code moet ingevuld worden'),
                    // })}

                    onSubmit={(values, {setSubmitting}) => {
                        setSubmitting(false);
                        handleSubmit(id, values);
                    }}
                >
                    <Modal.Body>
                        <FormField name={"project_form_name"}
                                   label={"Offertenaam:"}
                                   width={"100%"}
                                   placeholder="Vul de offertenaam hier in"
                                   className={"mb-3"}
                                   control={"input"}
                        />
                        <FormField name={"project_form_code"}
                                   label={"Offertereferentie"}
                                   width={"100%"}
                                   placeholder={"Vul de offertereferentie hier in"}
                                   rows={3}
                                   className={"mb-3"}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Annuleren
                        </Button>
                        <SubmitButton title={"Opslaan"} variant="primary"/>
                    </Modal.Footer>
                </FormikForm>
            </Modal>
        </>
    );
}

export default OfferProjectFormsModal;
